// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__qfKjf","sendOtp":"AuthorizeToLogin_sendOtp__WicMy"};